// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PzNkF{position:relative;width:85%}.PzNkF .eefSA{height:48px}.PzNkF .KQx0a{position:absolute;inset:0;display:flex;align-items:center;justify-content:flex-start;pointer-events:none;font:inherit;white-space:nowrap}.PzNkF .m4B28{visibility:hidden}.PzNkF .AE9Lf{pointer-events:auto;color:#000;display:inline-flex}.PzNkF .IpAHN{display:flex;min-width:0}.PzNkF .v7YUW{pointer-events:auto;display:inline-flex;margin-left:8px}.PzNkF:focus-within .KQx0a{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LegalTermsDropdown": `PzNkF`,
	"LegalTermsDropdownInput": `eefSA`,
	"anchorDefaultOverlay": `KQx0a`,
	"anchorDefaultMeasureText": `m4B28`,
	"anchorDefaultInfoIcon": `AE9Lf`,
	"itemDetailsTooltipTrigger": `IpAHN`,
	"anchorDefaultBadge": `v7YUW`
};
export default ___CSS_LOADER_EXPORT___;
